import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

function Accommodation_Section2() {
  const titlesDescriptionsObj = {
    "Enhances Guest Experience":
      "A clean and fresh space creates a lasting impression, ensuring guests feel comfortable and cared for throughout their stay.",
    "Protects Your Property":
      "Routine cleaning prevents wear and tear by maintaining furniture, appliances, and surfaces, extending their lifespan and saving you money on replacements.",
    "Supports Health and Hygiene":
      "Regular cleaning eliminates dust, allergens, and germs, providing a safe and healthy environment for your guests.",
    "Improves Online Reviews":
      "Cleanliness is a top priority for guests when leaving reviews. Regular cleaning helps secure positive feedback, boosting your ratings and attracting more bookings.",
    "Simplifies Turnovers":
      "Maintaining a consistently clean property reduces the effort and time needed for turnovers between guests, allowing for a smoother booking process.",
    "Builds Your Reputation":
      "A reputation for cleanliness and comfort sets your accommodation apart, encouraging repeat bookings and word-of-mouth recommendations.",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="Why Regular Cleaning is Essential for Your Accommodation?"
              contents="Maintaining a clean and welcoming environment is crucial for ensuring guest satisfaction and protecting your property’s reputation. Regular cleaning helps you provide a superior experience while safeguarding the long-term value of your accommodation. Here’s why it’s essential:"
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Accommodation_Section2;

// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
// import Stack from "@mui/material/Stack";
// import Divider from "@mui/material/Divider";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// import SubTitleContents from "reusables/TextFormats/SubTitleContents";
// import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

// function Accommodation_Section2() {
//   const titleDescriptionObjsArr = [{}];
//   return (
//     <Container>
//       <Grid container alignItems="center">
//         <Grid item display={"flex"} flexDirection={"column"}>
//           <Grid item>
//             <SubTitleContents
//               title="Why Regular Cleaning is Essential for Your Accommodation?"
//               contents="Maintaining a clean and welcoming environment is crucial for ensuring guest satisfaction and protecting your property’s reputation. Regular cleaning helps you provide a superior experience while safeguarding the long-term value of your accommodation. Here’s why it’s essential:"
//             />
//           </Grid>
//           <Grid item>
//             <Grid container>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">diversity_1</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Enhances Guest Experience
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         A clean and fresh space creates a lasting impression, ensuring guests feel
//                         comfortable and cared for throughout their stay.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">volunteer_activism</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Protects Your Property
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         Routine cleaning prevents wear and tear by maintaining furniture,
//                         appliances, and surfaces, extending their lifespan and saving you money on
//                         replacements.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">sentiment_satisfied</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Supports Health and Hygiene
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         Regular cleaning eliminates dust, allergens, and germs, providing a safe and
//                         healthy environment for your guests.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">diversity_1</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Improves Online Reviews
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         Cleanliness is a top priority for guests when leaving reviews. Regular
//                         cleaning helps secure positive feedback, boosting your ratings and
//                         attracting more bookings.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">diversity_1</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Simplifies Turnovers
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         Maintaining a consistently clean property reduces the effort and time needed
//                         for turnovers between guests, allowing for a smoother booking process.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//               <Grid item xs={12} lg={6}>
//                 <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                   <MKBox color="primary">
//                     <Icon fontSize="small">diversity_1</Icon>
//                   </MKBox>
//                   <MKBox display="flex" flexDirection="column">
//                     <MKBox>
//                       <MKTypography variant="body1" color="text" pl={2}>
//                         Builds Your Reputation
//                       </MKTypography>
//                     </MKBox>
//                     <MKBox>
//                       <MKTypography variant="body2" color="text" pl={2}>
//                         A reputation for cleanliness and comfort sets your accommodation apart,
//                         encouraging repeat bookings and word-of-mouth recommendations.
//                       </MKTypography>
//                     </MKBox>
//                   </MKBox>
//                 </MKBox>
//               </Grid>
//             </Grid>

//             <Divider sx={{ width: "100%", my: 2, borderWidth: 2 }} />

//             <CheckList_TwoColumns />
//           </Grid>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// }

// export default Accommodation_Section2;
